// This file is used for maintain and manage API services.
(function() {
    'use strict';
    angular.module('obex').
    factory('categories', ['$http', 'obexConstant', 'authService',
      function($http, obexConstant, authService) {
        return {
          addCategory(category) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const postData = {                
                Name: category.Name
              };
              return $http.post(obexConstant.urlCategory, postData, {
                headers: authHeader,
              });
            });
          },
          getCategories() {
            return authService.getAuthorizationHeader().then(authHeader => {
              return $http.get(obexConstant.urlCategory, {
                headers: authHeader,
              });
            });
          },
          getCategoryById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlCategory}/id/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          updateCategory(id, category) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlCategory}/id/${id}`;
              const putData = {
                Id: category.Id,
                Name: category.Name
              };
              return $http.put(url, putData, {
                headers: authHeader,
              });
            });
          },
          deleteCategory(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlCategory}/id/${id}`;
              return $http.delete(url, {
                headers: authHeader,
              });
            });
          },
        };
      },
    ]);
  })();


// WEBPACK FOOTER //
// ./client/js/services/categories.service.js